import React, { useEffect } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'
import MDDropdown from 'components/MDDropdown'

// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import DataTable from 'components/Tables/DataTable'

// zerouno
import userService from 'services/user.service'
import companyService from 'services/company.service'
import CompanyDialog from 'views/crm/CompanyDialog'
import { Link } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'

export default function CompanyTable () {
  const [objId, setObjId] = React.useState(0)
  const [obj, setObj] = React.useState({})
  const [objects, setObjects] = React.useState([])
  const [showSnackbar, setShowSnackbar] = React.useState({ sh: false, msg: '', color: 'success' })
  const [openConfirm, setOpenConfirm] = React.useState(false)
  const [openDialog, setOpenDialog] = React.useState(false)
  const [openMenuActions, setOpenMenuActions] = React.useState(false)

  useEffect(() => {
    fetchObjects()
  }, [])

  const fetchObjects = () => {
    companyService.getAll().then(
      (response) => {
        setObjects(response.data)
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const fetchObject = async (id) => {
    try {
      const response = await companyService.get(id)
      return response.data
    } catch (error) {
      setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
    }
  }

  // Delete
  const deleteObject = (id) => {
    setOpenConfirm(false)
    companyService.remove(id).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        fetchObjects()
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  // Add obj
  const addObj = (data) => {
    companyService.create(data).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        fetchObjects()
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  // Update obj
  const updateObj = (data, id) => {
    companyService.update(id, data).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        fetchObjects()
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const openFormDialog = (obj) => {
    if (obj !== '') {
      fetchObject(obj.id).then((objWithUsers) => {
        obj.users = objWithUsers.users
        setObj(obj)
        setOpenDialog(true)
      })
    } else {
      setObj({})
      setOpenDialog(true)
    }
  }

  const closeUserDialog = () => {
    setOpenDialog(false)
  }

  const columns = [
    {
      Header: 'nome',
      accessor: 'name'
    },
    {
      Header: 'p. iva',
      accessor: 'vat'
    },
    {
      Header: 'c.f.',
      accessor: 'fiscalCode'
    },
    {
      Header: 'azioni',
      sortable: false,
      filterable: false,
      width: 100,
      accessor: 'id',
      Cell: ({ value, row }) => (
        <Grid container spacing={1}>
          {/* <MDButton
              size='small'
              color='info'
              id='basic-button'
              aria-controls={openMenuActions ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={openMenuActions ? 'true' : undefined}
              onClick={handleOpenMenuActions}
              variant='gradient'
            >
              azioni
            </MDButton> */}
          <Grid item>
            <MDButton
              color='info'
              size='small'
              iconOnly
              component={Link}
              to={'/companies/' + value}
            >
              <Icon>edit</Icon>
            </MDButton>
          </Grid>
        </Grid>
      )
    }
  ]

  const handleOpenMenuActions = (event) => {
    if (openMenuActions && openMenuActions.contains(event.target)) {
      setOpenMenuActions(null)
    } else {
      setOpenMenuActions(event.currentTarget)
    }

    // setOpenMenuActions(event.currentTarget)
  }
  const handleCloseMenuActions = () => setOpenMenuActions(null)
  const renderMenuActions = (value) => (
    <Menu
      id='basic-menu'
      anchorEl={openMenuActions}
      open={Boolean(openMenuActions)}
      onClose={handleCloseMenuActions}
      MenuListProps={{
        'aria-labelledby': 'basic-button'
      }}
      sx={{ mt: 2 }}
    >
      <MenuItem key='sedi' component={Link} to={'/customers/' + value + '/addresses'}>Sedi</MenuItem>
      <MenuItem key='doc' component={Link} to={'/customers/' + value + '/documents'}>Documenti</MenuItem>
      <MenuItem key='ordini' component={Link} to={'/customers/' + value + '/orders'}>Ordini</MenuItem>
      <MenuItem key='todo' component={Link} to={'/customers/' + value + '/todos'}>Todo</MenuItem>
    </Menu>
  )

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <ZUTitleForm bgColor='info' title='Aziende' icon='language' />

          <MDBox p={3} lineHeight={1}>
            {/* <MDButton
              size='small'
              color='info'
              id='basic-button'
              aria-controls={openMenuActions ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={openMenuActions ? 'true' : undefined}
              onClick={handleOpenMenuActions}
              variant='gradient'
            >
              azioni
            </MDButton>
            {renderMenuActions('e')} */}
          </MDBox>
          <MDBox p={3} lineHeight={1}>
            {/* <MDButton color='info' component={Link} to='/customers/new' m={1}>
              aggiungi
            </MDButton> */}
          </MDBox>
          <DataTable table={{ columns: columns, rows: objects }} canSearch />
        </Card>
      </MDBox>
      <Footer />

      {/* <CompanyDialog
        obj={obj}
        open={openDialog}
        onClose={closeUserDialog}
        add={addObj}
        upd={updateObj}
      /> */}
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>Conferma</MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>

  )
}
